export default "__VITE_ASSET__BC1Ddc39__"